import React from 'react';
import PropTypes from 'prop-types';

const SettingsIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
        <path d="M15.609 6.475l-1.679-.56a6.264 6.264 0 00-.262-.631L14.46 3.7a.571.571 0 00-.107-.659l-1.389-1.393a.573.573 0 00-.659-.107l-1.583.792a6.069 6.069 0 00-.636-.262L9.526.392A.572.572 0 008.983 0H7.017a.571.571 0 00-.542.391l-.56 1.679a6.241 6.241 0 00-.631.262L3.7 1.54a.572.572 0 00-.659.107L1.647 3.036a.571.571 0 00-.107.659l.792 1.589a6.241 6.241 0 00-.262.631l-1.679.559A.572.572 0 000 7.017v1.966a.57.57 0 00.391.542l1.679.56a6.2 6.2 0 00.262.636L1.54 12.3a.571.571 0 00.107.659l1.389 1.389a.57.57 0 00.659.107l1.589-.792a6.376 6.376 0 00.631.262l.559 1.679a.573.573 0 00.543.396h1.965a.57.57 0 00.542-.391l.56-1.679a6.143 6.143 0 00.636-.262l1.583.792a.568.568 0 00.659-.107l1.389-1.389a.571.571 0 00.107-.659l-.792-1.583a6.142 6.142 0 00.262-.636l1.679-.56A.572.572 0 0016 8.983V7.017a.571.571 0 00-.391-.542zm-.752 2.1l-1.563.522a.57.57 0 00-.369.383 5.073 5.073 0 01-.4.975.572.572 0 00-.007.525l.736 1.472-.806.806-1.472-.736a.569.569 0 00-.525.007 5.073 5.073 0 01-.975.4.572.572 0 00-.383.369l-.522 1.563H7.429l-.521-1.563a.572.572 0 00-.383-.369 5.047 5.047 0 01-.97-.4.571.571 0 00-.524-.007l-1.477.737-.807-.806.736-1.472a.571.571 0 00-.007-.525 5.045 5.045 0 01-.4-.975.572.572 0 00-.369-.383l-1.563-.522V7.429l1.563-.521a.57.57 0 00.369-.384 4.94 4.94 0 01.4-.969.573.573 0 00.007-.524l-.737-1.478.807-.807 1.477.737a.571.571 0 00.524-.007 4.94 4.94 0 01.969-.4.57.57 0 00.384-.369l.522-1.563h1.142l.522 1.563a.572.572 0 00.383.369 5.081 5.081 0 01.975.4.571.571 0 00.525.007l1.472-.736.806.807-.737 1.477a.569.569 0 00.007.524 5.01 5.01 0 01.4.97.572.572 0 00.369.383l1.563.521zM8 4.571A3.429 3.429 0 1011.429 8 3.432 3.432 0 008 4.571zm0 5.714A2.286 2.286 0 1110.286 8 2.288 2.288 0 018 10.286z" fill={fill} />
    </svg>
);

SettingsIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

SettingsIcon.defaultProps = {
    width: '16',
    height: '16',
    fill: '#4b254e'
};

export default SettingsIcon;
